import ManualCarousel, {
  CarouselItem,
} from "../components/news-carousel/NewsCarousel";

import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import {
  Button,
  CardActions,
  DialogContentText,
  Typography,
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useState } from "react";

const News = ({ isMobile, news }) => {
  const [open, setOpen] = useState(false);
  const [cardData, setCardData] = useState([]);

  const cards = [];
  let chunkSize;
  if (isMobile) {
    chunkSize = 1;
  } else {
    chunkSize = 3;
  }

  for (let i = 0; i < news?.length; i += chunkSize) {
    const chunk = news?.slice(i, i + chunkSize);
    cards.push(chunk);
  }

  const handleClickOpen = (data) => {
    setOpen(true);
    setCardData(data);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle style={{ fontWeight: "bold" }} id="alert-dialog-title">
          {cardData?.title}
        </DialogTitle>
        <DialogContent>
          <DialogContent id="alert-dialog-description">
            <CardMedia
              className="w-40 h-40 md:w-60 md:h-60 lg:w-48 lg:h-48 xl:w-80 xl:h-80 transform transition-all duration-100 ease-linear"
              component="img"
              height="150"
              image={cardData?.coverImage}
              alt="Article"
            />

            <DialogContentText style={{ fontSize: "1.3em" }}>
              {cardData?.description}
            </DialogContentText>
          </DialogContent>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} autoFocus>
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <div className="my-8 bg-transparent xl:w-4/5 mx-10 xl:mx-auto overflow-x-hidden">
        <h2 className="text-4xl lg:text-5xl tracking-wide mt-10 mb-40">
          Our News
        </h2>
        <div className="grid grid-cols-3 lg:grid-cols-4">
          <div className="w-3/4 hidden lg:block">
            <h3 className="text-2xl xl:text-3xl tracking-wide">
              Explore Our News
            </h3>
            <p className="text-sm xl:text-base">
              Get a glimpse of how we work to improve lives
            </p>
            <div className="h-0.5 w-full bg-black mt-8"></div>
          </div>

          <ManualCarousel className="col-span-3 h-96 overflow-x-clip">
            {cards.map((card, i) => (
              <CarouselItem key={i}>
                {card.map((c) => (
                  <Card
                    sx={{ maxWidth: 350, maxHeight: 500 }}
                    key={c._id}
                    className="transform transition-all duration-100 ease-linear hover:border-2 border-blue-600 border-opacity-60 hover:shadow-xl"
                  >
                    <CardMedia
                      className="p-3 transform transition-all duration-100 ease-linear hover:p-0 max-h-60"
                      component="img"
                      height="150"
                      image={c.coverImage}
                      alt="Article"
                    />
                    <CardContent>
                      <Typography
                        style={{ fontSize: "1.3rem" }}
                        gutterBottom
                        variant="h5"
                        component="div"
                      >
                        {c.title}
                      </Typography>

                      <Typography
                        variant="caption"
                        className="inline-block whitespace-pre-line"
                        color="text.secondary"
                      >
                        {c.description.slice(0, 100)}...
                      </Typography>
                    </CardContent>
                    <CardActions className="flex justify-end btn-container">
                      <Button
                        onClick={() => handleClickOpen(c)}
                        style={{
                          backgroundColor: "#001A6C",
                          textTransform: "capitalize",
                          borderRadius: "0",
                        }}
                        variant="contained"
                        size="small"
                        color="primary"
                      >
                        Read More
                      </Button>
                    </CardActions>
                  </Card>
                ))}
              </CarouselItem>
            ))}
          </ManualCarousel>
        </div>
      </div>
    </>
  );
};

export default News;
